import React from 'react'
import { Button, Col, Spinner } from 'react-bootstrap'

type Props = {
  isLoading: boolean
  onDelete: () => void
}
const EditButtonGroup = ({ isLoading, onDelete }: Props) => {
  return (
    <>
      <Col lg={5} className="mx-auto" data-testid="edit-button-group">
        <Button
          data-testid="delete-button"
          variant="danger"
          type="button"
          className="mt-5"
          disabled={isLoading}
          onClick={() => {
            onDelete()
          }}
        >
          Delete
        </Button>
        <Button
          variant="primary"
          type="submit"
          className="mt-5 ml-2"
          disabled={isLoading}
          data-testid="save-button"
        >
          {isLoading && (
            <span className="mr-2">
              <Spinner
                animation="border"
                size="sm"
                className="text-white"
                data-testid="edit-spinner"
              />
            </span>
          )}
          Save Changes
        </Button>
      </Col>
    </>
  )
}

export default EditButtonGroup
